/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum EntityType {
  Buyer = 'Buyer',
  Convener = 'Convener',
  Consortium = 'Consortium',
}
